export class Language {

    id?: string;
    identifier?: number;
    isActive?: boolean;
    keyCode?: string;
    predetermined?: boolean;
    icon?: string;
    name?: string;

    constructor(source: Partial<Language>) {
        Object.assign(this, source);
    }
}